import InputSuffixIcon from "@/components/InputSuffixIcon";
import { ReactComponent as IconSearch } from "@/assets/svgs/icon-search.svg";
import PropTypes from 'prop-types';
import Search from '@/componentsDS/Search/index';
import { feature } from "@/utils/feature-verifier";
import { featureConstant } from "@/constants/configuration/feature";

const SearchPersonaParticipantList = ({
	searchBoxValue,
	placeholderText,
	handleSearch,
	handleCancel,
	showTotal,
	list,
	DataElementsList
}) => {
	return (
		<div className="-search-wrapper">
			<div className="use-cases__search__box">
				{feature(featureConstant.NEW_DESIGN_SYSTEM) ? (
					<div style={{ maxWidth: '556px', minWidth: "100%" }}>
						<Search
							value={searchBoxValue}
							placeholder={placeholderText}
							onChange={(e) => {
								handleSearch(e.target.value);
							}}
							onCancel={handleCancel}
						/>
					</div>
				) : (
					<InputSuffixIcon
						maxWidth="556"
						placeholder={placeholderText}
						icon={<IconSearch />}
						value={searchBoxValue}
						onChange={(e) => {
							handleSearch(e.target.value);
						}}
					/>
				)}
			</div>
			{showTotal && <span className="total-elements">{list?.length} Data Elements </span>}
			<div className="view-info__selector-box-wrap">
				<DataElementsList data={list} />
			</div>
		</div>
	);
};

SearchPersonaParticipantList.propTypes = {
	searchBoxValue: PropTypes.string,
	placeholderText: PropTypes.string,
	handleSearch: PropTypes.func,
	handleCancel: PropTypes.func,
	showTotal: PropTypes.bool,
	list: PropTypes.array,
	DataElementsList: PropTypes.elementType,
};

export default SearchPersonaParticipantList;
